module.exports = __webpack_public_path__ + "static/media/table-1.a9015f44.webp";